module.exports = __webpack_public_path__ + "img/more.f9c6d7c6.svg";